<h2 mat-dialog-title class="dialog-title">{{ data.isEditMode ? 'Benutzer bearbeiten' : 'Benutzer erstellen' }}</h2>
<mat-dialog-content class="dialog-content">
  <form [formGroup]="userForm" (ngSubmit)="saveUser()">
    <mat-form-field appearance="outline">
      <mat-label>Benutzername</mat-label>
      <input matInput formControlName="username" required />
      <mat-error *ngIf="userForm.get('username')?.hasError('required')">
        Benutzername ist erforderlich
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>E-Mail</mat-label>
      <input matInput formControlName="email" required type="email" />
      <mat-error *ngIf="userForm.get('email')?.hasError('required')">
        E-Mail ist erforderlich
      </mat-error>
      <mat-error *ngIf="userForm.get('email')?.hasError('email')">
        Ungültige E-Mail-Adresse
      </mat-error>
    </mat-form-field>



    <mat-form-field appearance="outline">
      <mat-label>Gruppe</mat-label>
      <mat-select formControlName="roles">
        <mat-option *ngFor="let g of visibleGroupOptions" [value]="g.value">{{ g.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Lager-/Kunden-Zuordnung nur für eingeschränkte Gruppen und im Bearbeiten-Modus -->
    <ng-container *ngIf="data.isEditMode && isScopedGroup">
      <mat-form-field appearance="outline">
        <mat-label>Zugeordnete Hauptlager</mat-label>
        <mat-select formControlName="warehouseIds" multiple>
          <mat-option *ngFor="let w of warehouses" [value]="w.id">{{ w.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Zugeordnete Kunden</mat-label>
        <mat-select formControlName="customerIds" multiple>
          <mat-option *ngFor="let c of customers" [value]="c.id">{{ c.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <p class="hint-text" *ngIf="!data.isEditMode && isScopedGroup">
      Lager und Kunden können nach dem Anlegen über „Bearbeiten" zugeordnet werden.
    </p>


    <button mat-stroked-button color="accent" type="button" class="reset-button" *ngIf="data.isEditMode"
            (click)="openResetPasswordDialog()" [disabled]="resetInProgress">
      <mat-icon>key</mat-icon>
      <span>Einmalpasswort senden</span>
      <mat-progress-spinner *ngIf="resetInProgress" diameter="16" strokeWidth="3" mode="indeterminate"></mat-progress-spinner>
    </button>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-stroked-button type="button" (click)="dialogRef.close()">Abbrechen</button>
  <button mat-raised-button color="primary" type="submit" (click)="saveUser()" [disabled]="!userForm.valid || isLoading">
    <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
    {{ data.isEditMode ? 'Speichern' : 'Erstellen' }}
  </button>

</mat-dialog-actions>
